import {Typetechno} from './typetechno';

export class Techno {
  id: number;
  libelle: string;
  typetechno: Typetechno;
}
